import FileSelect from '../../../../../components/FileSelect';
import { useEffect, useRef, useState } from 'react';
import { FunRowItemS } from '../../../../Project/Funds/style';
import { IoClose } from 'react-icons/io5';
import { HiddenButton } from './style';
import { idCreator } from '../../../../Project/utils/idCreator';

export default function SourceFundItem({
  idPrefix,
  options,
  source,
  sheetId,
  onSelectSourceFund,
  selectedFile,
  isCreateLoading,
  isUpdateLoading,

  handleCreateSourceFund,
  handleUpdateSourceFund,
  disabled,
  isDragging,
  isDraggedElement,

  setIsCreatingNew
}) {
  const inputRef = useRef();
  const rootId = idPrefix || `data-extraction-source-fund-${idCreator(source?.id || source?.name)}`;

  const [name, setName] = useState(source?.name);
  const [isEdit, setIsEdit] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [isHoveredOnDrag, setIsHoveredOnDrag] = useState(false);

  useEffect(() => {
    setIsHoveredOnDrag(false);
  }, [isDragging]);

  const onMouseEnter = () => {
    if (isDraggedElement) return;

    setIsHoveredOnDrag(true);
  };

  const onMouseLeave = () => {
    if (isDraggedElement) return;

    setIsHoveredOnDrag(false);
  };

  const onDelete = () => {
    onSelectSourceFund(null);
  };

  const handleSubmit = e => {
    e?.preventDefault();

    if (!name) {
      setIsCreate(false);
      setIsEdit(false);
      setIsCreatingNew(false);
      return;
    }

    if (isEdit)
      handleUpdateSourceFund(
        {
          id: selectedFile.value,
          data: {
            name: name
          }
        },
        res => {
          setName('');
          onSelectSourceFund(res);
          setIsEdit(false);
          setIsCreate(false);
          setIsCreatingNew(false);
        }
      );
    else
      handleCreateSourceFund(
        {
          name: name,
          sheet_id: sheetId
        },
        res => {
          onSelectSourceFund(res);
          setName('');
          setIsEdit(false);
          setIsCreate(false);
          setIsCreatingNew(false);
        }
      );
  };

  const onCreateNewFund = value => {
    handleCreateSourceFund(
      {
        name: value,
        sheet_id: sheetId
      },
      res => {
        onSelectSourceFund(res);
      }
    );
  };

  const onUpdateFund = (id, name, onSuccess) => {
    handleUpdateSourceFund(
      {
        id,
        data: {
          name
        }
      },
      res => {
        onSelectSourceFund(res);
      }
    );
  };

  useEffect(() => {
    setName(selectedFile?.name || '');
  }, [selectedFile]);

  if (isCreate || isEdit)
    return (
      <EditableRow
        idPrefix={rootId}
        value={name}
        setValue={setName}
        inputRef={inputRef}
        handleSubmit={handleSubmit}
        handleEdit={handleSubmit}
        isUpdateLoading={isUpdateLoading || isCreateLoading}
      />
    );

  const emptySource = !source?.source_fund;

  return (
    <FileSelect
      idPrefix={rootId}
      hasIcon={false}
      hasError={emptySource}
      readOnly={disabled}
      disabled={!emptySource || isDragging}
      onSelectOption={onSelectSourceFund}
      selectedFile={selectedFile}
      hovered={isHoveredOnDrag}
      active={isDraggedElement}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onCreateNewFund={onCreateNewFund}
      onUpdateFund={onUpdateFund}
      options={options}
      isSourceFund
      isCreateLoading={isCreateLoading}
      isUpdateLoading={isUpdateLoading}
    >
      {!emptySource && !disabled && <IoClose onClick={onDelete} color="#868E96" fontSize="16px" />}
    </FileSelect>
  );
}

const EditableRow = ({ idPrefix, handleSubmit, inputRef, value, setValue, isUpdateLoading }) => {
  return (
    <FunRowItemS id={`${idPrefix}-edit-root`}>
      <form onSubmit={handleSubmit} data-testid="form" id={`${idPrefix}-form`}>
        <input
          id={`${idPrefix}-input`}
          disabled={isUpdateLoading}
          ref={inputRef}
          value={value}
          autoFocus
          onChange={e => setValue(e.target.value)}
        />
        <HiddenButton id={`${idPrefix}-submit`} type="submit"></HiddenButton>
      </form>
    </FunRowItemS>
  );
};
